import { Outlet, useParams } from "react-router-dom"
import {
  CalendlyStatus,
  If,
  NoConversationMsg,
  PageHeader
} from "../../common/ui"
import { Fragment } from "react"
import useConversations from "../../common/hooks/use-conversations"
import { useGetCalendarIntegrationQuery } from "../../redux/queries"

const Conversations = () => {
  const { threads, isLoading } = useConversations()

  const { _id = "" } = useParams<{ _id: string }>()

  const { data, isFetching } = useGetCalendarIntegrationQuery(
    { thread_id: _id },
    { skip: !_id }
  )

  return (
    <Fragment>
      <div className="p-6 bg-white border-b border-neutral-200">
        <PageHeader title="Conversations">
          <If
            condition={!!_id && !isFetching}
            then={<CalendlyStatus on={!Array.isArray(data)} />}
          />
        </PageHeader>
      </div>

      {threads?.length === 0 && !isLoading ? <NoConversationMsg /> : <Outlet />}
    </Fragment>
  )
}

export default Conversations
